import type { TMessages } from '@/types/TMessages'

export const messages = {
  comment: 'Что можно улучшить?',
  placeholder: 'Ваше сообщение (необязательно)',
} as const satisfies TMessages
